import { Navigate } from "react-router-dom";
import { HOME_PATH } from "../nav";

/** Accueil commun à tous les rôles : la journée d'hier, pas la badgeuse. Le
 * dirigeant reçoit son temps du kit ; le récap d'équipe reste lié depuis là. */
export function HomeRedirect() {
  return <Navigate to={HOME_PATH} replace />;
}
